import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import BuildQuerySearch from './Components/BuildQuerySearch';
import BuildQueryHeading from './Components/BuildQueryHeading';
import BuildQueryContentInfo from './Components/BuildQueryContentInfo';

import './BuildQuery.scss';

function BuildQuery(props) {
  const { initialize, structurePreview, isAIQuickSearchBannerDisabled } = props;
  const [promptInputFocusTrigger, setPromptInputFocusTrigger] = useState(0);

  const onExampleApplied = () => {
    setPromptInputFocusTrigger((currentValue) => currentValue + 1);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={`build-query ${isAIQuickSearchBannerDisabled ? 'build-query--banner-disabled' : 'build-query--banner-enabled'}`}>
      <BuildQueryHeading {...props} onExampleApplied={onExampleApplied} />
      <section
        className={cn('build-query__wrapper', {
          'build-query__wrapper--with-structure': structurePreview,
        })}
        id="main-content">
        <BuildQuerySearch {...props} onExampleApplied={onExampleApplied} promptInputFocusTrigger={promptInputFocusTrigger} />
        <BuildQueryContentInfo />
      </section>
    </div>
  );
}

BuildQuery.propTypes = {
  initialize: PropTypes.func.isRequired,
  isAIQuickSearchBannerDisabled: PropTypes.bool,
};

export default BuildQuery;
